export enum ApiActionType {
  Request = '@quidproquo-webserver/Api/Request',
}
